import React, { useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import MfaVerification from '../../components/MfaVerification';

// Standalone modal for MFA verification during login
export const MfaModal = ({ verificationId, resolver, onSuccess, onCancel }) => {
  // Lock body scroll when modal is open
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    
    return () => {
      document.body.style.overflow = '';
    };
  }, []);
  
  return (
    <div className="fixed inset-0 backdrop-blur-xl flex items-center justify-center p-2 sm:p-4 z-50 bg-black/50 overflow-y-auto">
      <div className="max-w-md w-full my-4">
        <MfaVerification 
          verificationId={verificationId}
          resolver={resolver}
          onSuccess={onSuccess}
          onCancel={onCancel}
        />
      </div>
    </div>
  );
};

// Create a function to mount the modal
export const showMfaModal = (verificationId, resolver) => {
  return new Promise((resolve, reject) => {
    console.log("📝 DEBUG: Showing MFA modal with resolver:", resolver ? "Valid" : "Invalid");
    
    // Validation check
    if (!resolver || typeof resolver.resolveSignIn !== 'function') {
      console.error("❌ DEBUG: Invalid resolver in showMfaModal");
      reject(new Error("Authentication error: Invalid session. Please try signing in again."));
      return;
    }
    
    // Create a div for the modal
    const modalDiv = document.createElement('div');
    modalDiv.id = 'mfa-modal-container';
    document.body.appendChild(modalDiv);
    
    // Create root for React rendering
    const root = createRoot(modalDiv);
    
    // Handle success
    const handleSuccess = (userCredential) => {
      // Clean up and remove the modal
      try {
        root.unmount();
        document.body.removeChild(modalDiv);
      } catch (err) {
        console.warn("Error cleaning up MFA modal:", err);
      }
      resolve(userCredential);
    };
    
    // Handle cancel
    const handleCancel = () => {
      // Clean up and remove the modal
      try {
        root.unmount();
        document.body.removeChild(modalDiv);
      } catch (err) {
        console.warn("Error cleaning up MFA modal:", err);
      }
      reject(new Error("MFA verification cancelled"));
    };
    
    // Render the modal
    root.render(
      <MfaModal 
        verificationId={verificationId}
        resolver={resolver}
        onSuccess={handleSuccess}
        onCancel={handleCancel}
      />
    );
  });
}; 